import { Box, Button, makeStyles } from '@material-ui/core';
import { FunctionComponent } from 'react';
import { useHistory } from 'react-router-dom';

export const ReferralOnePagerButton: FunctionComponent = () => {
  const classes = useStyles();
  const history = useHistory();

  function onClickHandler() {
    return history.push('/referral-one-pager');
  }

  return (
    <Button
      variant="outlined"
      color="primary"
      className={classes.button}
      onClick={onClickHandler}
      data-testid="referral-one-pager-button"
    >
      <Box fontSize={16} fontWeight={700}>
        Referral One Pager
      </Box>
    </Button>
  );
};

const useStyles = makeStyles({
  button: {
    width: 200,
    height: 50,
    borderWidth: 2,
    '&:hover': {
      borderWidth: 2,
    },
  },
});
